export const automotiveUsersKeys = {
  user: () => ['USER_AUTOMOTIVE'] as const,
  customer_user: (customerId: string, role: string) =>
    ['USER_AUTOMOTIVE', customerId, role] as const,
};
